const columns = [
	{
		label: 'Common Code Type',
		msgKey: 'SWCC000142',
		prop: 'commCdType'
	},
	{
		label: 'Common Code',
		msgKey: 'SWCC000150',
		prop: 'commCd'
	},
	{
		label: 'Sequence',
		msgKey: 'SWCC000373',
		prop: 'seq'
	},
	{
		label: 'Code Desc',
		msgKey: 'SWCC000384',
		prop: 'cdDesc',
		form: {
			type: 'input',
			maxLength: 1000
		}
	},
	{
		label: 'Title',
		msgKey: 'SWCC000519',
		prop: 'title',
		form: {
			type: 'input',
			maxLength: 100
		}
	}
];

export default columns;
